<template>
  <b-container fluid>
    <b-row>
      <b-col id="reportConsoleLeftSide" lg="4" md="4" sm="12">
        <appInvoiceGenerate></appInvoiceGenerate>
      </b-col>

      <b-col id="reportConsoleLeftSide" lg="4" md="4" sm="12">
        <appInvoiceView></appInvoiceView>
      </b-col>
    </b-row>

    <b-row>
      <b-col id="reportConsoleRightSide" lg="12" md="12" sm="12">
        <div v-if="stakeHolderTypeView == 'de'">
          <appVSAEOMDEInvoice
            :prosData="getInvoiceData"
            :invoiceYear="invoiceYearView"
            :invoiceMonth="invoiceMonthView"
            :stakeHolderType="stakeHolderTypeView"
          >
          </appVSAEOMDEInvoice>
        </div>
        <div v-if="stakeHolderTypeView == 'rp'">
          <appVSAEOMRPInvoice
            :prosData="getInvoiceData"
            :invoiceYear="invoiceYearView"
            :invoiceMonth="invoiceMonthView"
            :stakeHolderType="stakeHolderTypeView"
          >
          </appVSAEOMRPInvoice>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import datePicker from 'vue2-datepicker'
import appInvoiceGenerate from '../../../components/admin/invoice/InvoiceGenerate.vue'
import appInvoiceView from '../../../components/admin/invoice/InvoiceView.vue'
import appVSAEOMDEInvoice from '../../../components/admin/invoice/VSAEOMDEInvoice.vue'
import appVSAEOMRPInvoice from '../../../components/admin/invoice/VSAEOMRPInvoice.vue'

export default {
  name: 'Report',
  components: {
    datePicker,
    appInvoiceGenerate,
    appInvoiceView,
    appVSAEOMDEInvoice,
    appVSAEOMRPInvoice
  },
  mounted() {},
  data() {
    return {
      errors: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getInvoiceViewParam', 'getInvoiceData']),
    invoiceYearView() {
      return this.getInvoiceViewParam.invoiceYearView
    },
    invoiceMonthView() {
      return this.getInvoiceViewParam.invoiceMonthView
    },
    stakeHolderTypeView() {
      return this.getInvoiceViewParam.stakeHolderTypeView
    }
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
@page {
  /* size: A4 portrait;  */
  width: 210mm;
  height: 280mm;
  margin: 20px 20px 20px 20px;
  padding: 0;
}
@media print {
  body * {
    visibility: hidden;
  }
  #quickQuotePage {
    display: none !important;
  }
  #quickQuotePage2 {
    display: none !important;
  }
  #printMe,
  #printMe * {
    visibility: visible !important;
  }
  #printMe {
    position: absolute !important;
    left: 0px !important;
    top: 0px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
